module.exports = __webpack_public_path__ + "img/BN.048953ef.png";